// extracted by mini-css-extract-plugin
export default {"listFormations":"list_listFormations__l46hN","header":"list_header__MlSkD","filters":"list_filters__TCgbh","rotate":"list_rotate__1T+bV"};